// extracted by css-extract-rspack-plugin
export default {"navigateBackButtonRoot":"navigateBackButtonRoot-akreb2"};